import { Pipeline, TriggerPipelineOnClick, useEnvValue } from '@morningtrain/react-helpers'
import Button from 'ui/buttons/Button'
import RedirectOnPipe from 'support/pipelines/pipes/RedirectOnPipe'
import { useRouter } from '@morningtrain/react-navigation'
import { Translation } from '@morningtrain/react-translations'
import { ExecuteOperationOnPipe } from '@morningtrain/react-resources'

export default function ImpersonationBar (props) {
  const router = useRouter()

  const [isImpersonating] = useEnvValue('globals.is_impersonating')
  const [nameOfUser] = useEnvValue('user.name')

  if (!isImpersonating) {
    return null
  }

  return (
    <div className='w-full bg-red-800 p-4 space-x-4 text-gray-100'>
      <span>
        <Translation name='auth.impersonation.currently_impersonating' data={{ user: nameOfUser }} />
      </span>
      <Pipeline>
        <TriggerPipelineOnClick>
          <Button color='white'><Translation name='auth.impersonation.stop_impersonating' /></Button>
        </TriggerPipelineOnClick>
        <ExecuteOperationOnPipe namespace='auth' resourceName='login' operationName='stop_impersonation' />
        <RedirectOnPipe routeName={router.redirectOnLoginRoute} />
      </Pipeline>
    </div>
  )
}
